export default {
      id: "dashboard-usage",
      viewBox: "0 0 132 87",
      url: __webpack_public_path__ + "icons-sprite.102705a.svg#dashboard-usage",
      toString: function () {
        return this.url;
      }
    }